import React, { useState } from "react";
import "./Coupon_canvas.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import Coupon_Card from "../../common_components/coupon_card/Coupon_Card";
import { CouponApplyed } from "../../../../features/order/orderSlice";
import { useDispatch } from "react-redux";

const Coupon_canvas = ({ data, setCouponData, price, coupons, ...props }) => {
  const [show, setShow] = useState(true);
  const [applied, setApplied] = useState(true);

  const dispatch = useDispatch();

  const handleClose = () => setShow(false);

  const handelSubmit = async (val) => {
    const handelSubmitdata = {
      amount: data?.total_selling_price || price,
      code: val?.code
    }
    const res = await dispatch(CouponApplyed({ data: handelSubmitdata }));
    if (res.meta?.requestStatus === "fulfilled") {
      setCouponData(val);
      props?.onHide()
      setApplied(val)
    } else if (res.meta?.requestStatus === "rejected") {
      alert(res.payload?.response?.data?.errors || "Somthing went Wrong")
      setApplied(false)

    }



  };




  return (
    <Offcanvas
      className="Confirm_delivery_add_offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
      {...props}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <FontAwesomeIcon icon={faTags} className="tag_icon" /> Coupons
        </Offcanvas.Title>
        <div className="icon_holder" onClick={() => props?.onHide()}>
          <FontAwesomeIcon
            icon={faXmark}
            className="close_icon"

          />
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="coupon_cards_div">
          {coupons?.length <= 0 && "Coupon Not available"}
          {coupons?.map((val) => (
            <Coupon_Card val={val} applied={applied} data={data} price={price} handelSubmit={handelSubmit} />
          ))}
          {/* <Coupon_Card showtc />
          <Coupon_Card /> */}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Coupon_canvas;
